<div class="bg-[#F5F5F5]">
	<div [style.min-height]="minHeightStyle" class="flex flex-col justify-between min-h-screen">
		<div>
			<ng-container *ngTemplateOutlet="header"></ng-container>
		</div>
		<div class="grow mx-[20px] mt-[20px]">
			<ng-container *ngTemplateOutlet="body"></ng-container>
		</div>
		<div>
			<ng-container *ngTemplateOutlet="footer"></ng-container>
		</div>
	</div>
</div>


<ng-template #header>
	<ng-container *ngIf="!hideHeader else customHeader">
		<app-mobile-timeline-template-v2
			(goBack)="goBack()"
			[currentStep]="currentStep"
			[total]="totalStep"
			[version]="version"
			[previous]="previousTitle"
			[description]="description"
			[title]="title">
		</app-mobile-timeline-template-v2>
	</ng-container>
</ng-template>
<ng-template #body>
	<div class="flex bg-white rounded-[8px] p-[16px] justify-center">
		<div class="grow">
			<app-kamona-otp #kamonaOtp type="password" [noOfPin]="noOfPasscodeBox" [inputReadonly]="true"
			idV2="passcode" [version]="KamonaOtpVersion.version_2"></app-kamona-otp>
		</div>
	</div>
</ng-template>
<ng-template #footer>
	<div class="pb-[40px] pt-[24px]">
		<app-kamona-number-pad
			[totalAllowableKeyIndex]="totalAllowableKeyIndex"
			(emitKeyPadValue)="setPasscode($event)"
			(emitKeyPadValueDeleted)="handleDeletedPasscode($event)"
			(emitKeyPadValueEntered)="handleEnterPasscode($event)">
		</app-kamona-number-pad>
	</div>
</ng-template>
<ng-template #customHeader>
	<ng-content></ng-content>
</ng-template>

